<template>
  <div class="step">
    <el-form
      :model="form"
      ref="form"
      @submit.native.prevent="submitForm">
      <el-form-item
        :label="L10n('enter-email')"
        :rules="getValidationRule('required,email')"
        prop="email"
        class="material-style">
        <el-input v-model="form.email" name="email" ref="firstField"/>
      </el-form-item>
    </el-form>
    <div class="text-right">
      <el-button
        type="button"
        class="btn"
        ref="submit"
        @click="submitForm">
        {{L10n('send-code')}}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepEmail',
  props: { email: { type: String, required: true } },
  data () {
    return { form: { email: this.email } }
  },
  mounted () {
    setTimeout(_ => {
      this.setFocusElement(this)
    }, 700)
  },
  methods: {
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          let loading = this.$loading({ lock: true })
          const payload = {
            languageID: 1,
            rememberMe: true,
            email: this.form.email
          }
          this.$store.dispatch('accountGeneratePassword', payload)
            .then(_ => {
              loading.close()
              this.$emit('update:email', this.form.email)
              this.$emit('step', 'code')
            })
            .catch(error => {
              loading.close()
              this.requestErrorHandler(error, this.L10n('general-error'))
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>
